import type { MasterColumnDef, MasterScreenDefinition } from '@/features/masters';

/**
 * The submitted-forms list, described the way every master list is described --
 * so the masters' own list table (the one the Purchase Requests screen draws)
 * renders it: its headers, sorting, pager, page-size control, empty and loading
 * states, and a row menu offering exactly the actions listed here.
 *
 * The base the Purchase Requests channel spreads and overrides (its own key, title, columns and actions). The
 * Default Template Forms screen that used it as-is was removed on 2026-10-16.
 */

const COLUMNS: readonly MasterColumnDef[] = [
  { key: 'templateName', label: 'Template Name', sortKey: 'templateName', width: 'wide' },
  { key: 'referenceNo', label: 'Form Ref', sortKey: 'referenceNo' },
  { key: 'templateType', label: 'Template Type', sortKey: 'templateKind' },
  { key: 'divisionName', label: 'Division' },
  { key: 'createdBy', label: 'Submitted By', sortKey: 'createdBy' },
  { key: 'createdDate', label: 'Submitted On', sortKey: 'createdDate' },
  /* The workflow's current status -- "Pending Manager Review", "Completed" -- drawn as the Status pill. */
  { key: 'statusName', label: 'Status', sortKey: 'workflowStatus' },
];

export const SUBMISSIONS_DEFINITION: MasterScreenDefinition = {
  key: 'submitted-forms',
  title: 'Submitted Forms',
  recordNoun: 'Form',
  subtitle: 'Forms submitted from active templates, and the approvals they are waiting on.',
  icon: 'pi-file-edit',
  codePrefix: 'TFS',
  codePad: 6,
  codeLabel: 'Form Ref',
  nameLabel: 'Template Name',
  integratedLabel: '',
  canAdd: true,
  actions: ['view'],
  columns: COLUMNS,
  defaultColumns: COLUMNS.map((column) => column.key),
  formSections: [],
};
